import { render, staticRenderFns } from "./DiscrepancyReport.stags.vue?vue&type=template&id=1e8b6017&scoped=true&lang=html&"
import script from "./DiscrepancyReport.stags.vue?vue&type=script&lang=js&"
export * from "./DiscrepancyReport.stags.vue?vue&type=script&lang=js&"
import style0 from "./DiscrepancyReport.stags.vue?vue&type=style&index=0&id=1e8b6017&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8b6017",
  null
  
)

export default component.exports